/** @import {WithFeatureFlagsProps} from '../FeatureFlags/FeatureFlagsTypes' */

import withFeatureFlags from '../FeatureFlags/withFeatureFlags';

function LiveChat(/** @type {WithFeatureFlagsProps} */ props) {
    const liveChatScript = document.getElementById(window.raeEnv.liveChatId);
    const overrideColour = "#286B6E";
    
    if (props.featureEnabled("LiveChat")) {
        if (!liveChatScript) {
            window.lcw = () => {
                return {
                    footerProps: {
                        styleProps: {
                            downloadTranscriptButtonStyleProps: {
                                icon: {
                                    color: overrideColour,
                                },
                            },
                            audioNotificationButtonStyleProps: {
                                icon: {
                                    color: overrideColour,
                                },
                            }
                        },
                    },
                }
            }
            const script = document.createElement('script');
            script.id = window.raeEnv.liveChatId;
            script.src = window.raeEnv.liveChatSrc;
            script.setAttribute("data-app-id", window.raeEnv.liveChatDataAppId);
            script.setAttribute("data-org-id", window.raeEnv.liveChatDataOrgId);
            script.setAttribute("data-org-url", window.raeEnv.liveChatDataOrgUrl);
            script.setAttribute("data-font-family-override", "Arial, Segoe UI");
            script.setAttribute("data-color-override", overrideColour);
            script.setAttribute("data-customization-callback", "lcw");
            document.body.appendChild(script);
        }
    } else {
        if (liveChatScript) {
            document.body.removeChild(liveChatScript);
        }
    }

    return (null);
};

export default withFeatureFlags(LiveChat);